import {Contract, ethers, parseEther} from "ethers";
import {
    minter_contract_constants,
    piku_contract_constants,
    pikuG_contract_constants, pikuVoting_contract_constants,
    usdc_contract_contants
} from "./Web3constants";

export async function getUsdcBalance(signer, user) {
    const contract = new Contract(usdc_contract_contants.address, usdc_contract_contants.ABI, signer);
    let balance = await contract.balanceOf(user);
    return ethers.formatEther(balance);
}

export async function getPikuBalance(signer, user) {
    const contract = new Contract(piku_contract_constants.address, piku_contract_constants.ABI, signer);
    let balance = await contract.balanceOf(user);
    return ethers.formatEther(balance);
}

export async function getPikuPrice(signer) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    let price = await contract.getPrice();
    console.log("price: " + ethers.formatEther(price));
    return ethers.formatEther(price);
}

export async function getPikuPriceHome() {

    
    // API URL'nizi ve authentication bilgilerinizi belirleyin
    const provider = new ethers.InfuraProvider('sepolia',
       "251ec3df87a34b3ba0a00e38ee0e317a",
        "VajZ1hvtvInfsenCIV50jMExl5EjED7rPALFkrx5bfDghEHYzFoomw"
    );
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, provider);
    let price = await contract.getPrice();
    return ethers.formatEther(price);
}


export async function approveUSDT(signer, amount) {
    const contract = new Contract(usdc_contract_contants.address, usdc_contract_contants.ABI, signer);
    let gasLimit = await contract.approve.estimateGas(minter_contract_constants.address, ethers.parseEther(amount.toString()));
    let tx = await contract.approve(minter_contract_constants.address, ethers.parseEther(
        amount.toString()
    ),
        {
            gasLimit: gasLimit,
        });
    let receipt = await tx.wait()
    return receipt;
}

export async function mintPiku(signer, amount) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    const gasLimit = await contract.mintPiku.estimateGas(ethers.parseEther(
        amount.toString()
    ));
    console.log("gasLimit: " + gasLimit);
    let tx = await contract.mintPiku(ethers.parseEther(
        amount.toString()
    ));

    let receipt = await tx.wait()
    return tx.hash;
}

export async function enterRedemtionQueue(signer, amount) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    const gasLimit = await contract.enterRedemptionQueue.estimateGas(ethers.parseEther(
        amount.toString()
    ));
    console.log("gasLimit: " + gasLimit);
    let tx = await contract.enterRedemptionQueue(ethers.parseEther(
        amount.toString()
    ), {
        gasLimit: gasLimit,
        nonce: undefined,
    });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return tx;
}
export async function enterRedemtionQueueCalculateGas(signer, amount) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    const gasLimit = await contract.enterRedemptionQueue.estimateGas(ethers.parseEther(
        amount.toString()
    ));
    return gasLimit;
}

export async function pikuApprove(signer, amount) {
    const contract = new Contract(piku_contract_constants.address, piku_contract_constants.ABI, signer);
    let gasLimit = await contract.approve.estimateGas(minter_contract_constants.address, ethers.parseEther(
        amount.toString()
    ));

    let tx = await contract.approve(minter_contract_constants.address, ethers.parseEther(
        amount.toString()
    ),
        {
            gasLimit: gasLimit,
        });
    let receipt = await tx.wait()

    return receipt;
}

export async function getRedemptionQueue(signer) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    let queue_size = Number(await contract.getQueueSize()) - 1;

    // console.log("queue_size: " + queue_size);
    // while (queue_size > 0) {
    //     let queue_item = await contract.getQueueElements(queue_size);
    //     if (queue_item[0] === await signer.getAddress()) {
    //         return queue_size;
    //     }
    //     queue_size = queue_size - 1;
    // }
    return queue_size;
}
export async function updateAllBalances(signer, user) {
    let usdc_balance = await getUsdcBalance(signer, user);
    let piku_balance = await getPikuBalance(signer, user);
    let piku_price = await getPikuPrice(signer);
    return {
        usdc_balance,
        piku_balance,
        piku_price,
    }
}
export async function isUserWhiteListed(signer) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    const whiteListRole = "0x57484954454c49535445525f524f4c4500000000000000000000000000000000"
    return await contract.hasRole(whiteListRole, await signer.getAddress());
}

export async function pikuGApprove(signer, amount) {
    const contract = new Contract(pikuG_contract_constants.address, pikuG_contract_constants.ABI, signer);
    let gasLimit = await contract.approve.estimateGas(pikuVoting_contract_constants.address, ethers.parseEther(
        amount
    ));
    let tx = await contract.approve(pikuVoting_contract_constants.address, ethers.parseEther(
        amount
    ),
        {
            gasLimit: gasLimit,
        });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return receipt;
}

export async function incLockPikuAmount(signer, amount, locktime) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let gasLimit = await contract.lockPiku.estimateGas(ethers.parseEther(
        amount.toString()
    ));
    let tx = await contract.lockPiku(ethers.parseEther(
        amount.toString()
    ),
        {
            gasLimit: gasLimit,
        });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return receipt;
}

export async function lockPikuGFirstTime(signer, amount, locktime) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    const locktimeInSeconds = Math.floor(new Date(locktime).getTime() / 1000);
    console.log("locktimeInSeconds before contract: " + locktimeInSeconds)
        let gasLimit = await contract.lock.estimateGas(ethers.parseEther(
            amount.toString()
        ), locktimeInSeconds) ;
        let tx = await contract.lock(ethers.parseEther(
                amount.toString()
            ), locktimeInSeconds,
            {
                gasLimit: gasLimit,
            });
        let receipt = await tx.wait()
        return receipt;
}

export async function incLockedPikugTime(signer, timestamp) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    console.log("locked time before contract "+ timestamp)
    let gasLimit = await contract.incTime.estimateGas(timestamp);
    let tx = await contract.incTime(timestamp,
        {
            gasLimit: gasLimit,
        });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return receipt;
}
export async function incLockedPikugAmount(signer, amount) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let gasLimit = await contract.incAmount.estimateGas(ethers.parseEther(
        amount.toString()
    ));
    let tx = await contract.incAmount(ethers.parseEther(
        amount.toString()
    ),
        {
            gasLimit: gasLimit,
        });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return receipt;
}

export async function getLockedPikuAmount(singer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, singer);
    let balance = await contract.getLockedAmount(await singer.getAddress());
    return ethers.formatEther(balance);
}

export async function getLockedPikuTime(signer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    const address = await signer.getAddress();
    let time = await contract.getLockedDuration(address);
    return time;
}

export async function getPikuGBalance(signer) {
    const contract = new Contract(pikuG_contract_constants.address, pikuG_contract_constants.ABI, signer);
    const address = await signer.getAddress();
    let balance = await contract.balanceOf(address);
    return ethers.formatEther(balance);
}

export async function getVePikuGAmount(singer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, singer);
    let balance = await contract.getVotingPower(await singer.getAddress());
    return ethers.formatEther(balance);
}

export async function claimPikuG(signer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let gasLimit = await contract.claim.estimateGas();
    let tx = await contract.claim(
        {
            gasLimit: gasLimit,
        });
    console.dir(tx);
    let receipt = await tx.wait()
    console.dir(receipt)
    return receipt;
}

export async function getTotalPikuSupply(signer) {
    const contract = new Contract(piku_contract_constants.address, piku_contract_constants.ABI, signer);
    let totalSupply = await contract.totalSupply();
    // console.log(totalSupply, "totalSupply")
    return ethers.formatEther(totalSupply);
}

export async function getLockedPikuPrice(signer) {
    const contract = new Contract(minter_contract_constants.address, minter_contract_constants.ABI, signer);
    let locked = await contract.totalLocked();
    return ethers.formatEther(locked)
}

export async function getLockedPikuGAmount(signer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let balance = await contract.getLockedAmount(await signer.getAddress());
    return ethers.formatEther(balance);
}


export async function getLockedPikugDate(signer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let timestamp = await contract.getLockedDuration(signer.getAddress());
    return timestamp;
}


export async function estimatePikuGRelaseAmaount(signer,date,vePikuGBalance){
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let balance = await contract.getLockedAmount(await signer.getAddress());
    let amount = await contract.estimate(true,balance,new Date(date).getTime()/1000);
    return ethers.formatEther(amount[1])- vePikuGBalance;
}

export async function estimatePikuGRelaseAmaountFirstTime(signer,pay,date){
    if (new Date(date).toDateString() === new Date().toDateString() ){
        return 0;
    }
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    let amount = await contract.estimate(true,pay,(new Date(date).getTime()/1000));
    return ethers.formatEther(amount[1]);
}
export async function getTotalPikuGSupply(signer){
    const contract = new Contract(pikuG_contract_constants.address, pikuG_contract_constants.ABI, signer);
    let totalSupply = await contract.totalSupply();
    return parseFloat(ethers.formatEther(totalSupply)).toFixed(2);
}

export async function calculateStats(signer) {
    const contract = new Contract(pikuVoting_contract_constants.address, pikuVoting_contract_constants.ABI, signer);
    const lockedTotal = ethers.formatEther(await contract.totalTokenLocked());
    const totalVotingPower = parseFloat(ethers.formatEther(await contract.getTotalVotingSupply())).toFixed(2);
    const totalSupply = await getTotalPikuGSupply(signer);
    const lockedPercentage = (lockedTotal / totalSupply) * 100;
    const multiplier = totalVotingPower / lockedTotal;
    const yearPart = Math.floor(multiplier);
    const monthPart = Math.floor((multiplier - yearPart) * 12);




    return {
        lockedTotal: lockedTotal,
        totalVotingPower: totalVotingPower,
        totalSupply: totalSupply,
        lockedPercentage: lockedPercentage,
        updatedDate: yearPart+" Year "+monthPart +" Month",
    };
}






